import script from "./PieTransaction.vue?vue&type=script&lang=js"
export * from "./PieTransaction.vue?vue&type=script&lang=js"

export default script